/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Button, FormTextInput } from "../../../components";
import { colors } from "../../../configs";
import Strings from "../../../translations";

const ItemPropertiesForm = (props) => {
  const {
    errorMessage,
    setMessage,
    handleChangeFormData = () => {},
    initialValue = {},
    actionType,
    handleModalClose,
  } = props;

  const [propertyName, setPropertyName] = useState({
    value: initialValue.name ?? "",
    error: false,
    success: false,
  });

  const [description, setDescription] = useState({
    value: initialValue.description ?? "",
    error: false,
    success: false,
  });

  /** --- Handlers --- */
  const handleChangePropertyName = (value) => {
    setMessage(null);
    setPropertyName(value);
  };

  const handleChangeDescription = (value) => {
    setDescription(value);
  };

  const handleSaveData = () => {
    const formData = {
      name: propertyName.value,
      description: description.value,
    };
    handleChangeFormData(formData);
  };

  /** --- Strings --- */
  const CreateTitle = Strings["ItemProperties.CreateTitle"],
    EditTitle = Strings["ItemProperties.EditTitle"],
    NameLabel = Strings["ItemProperties.NameLabel"],
    NamePlaceholder = Strings["ItemProperties.NamePlaceholder"],
    NameCustomError = Strings["ItemProperties.NameCustomError"],
    DescriptionLabel = Strings["ItemProperties.DescriptionLabel"],
    DescriptionPlaceholder = Strings["ItemProperties.DescriptionPlaceholder"],
    DescriptionCustomError = Strings["ItemProperties.DescriptionCustomError"],
    SaveBtn = Strings["ItemProperties.SaveBtn"],
    UpdateBtn = Strings["ItemProperties.UpdateBtn"],
    CancelBtn = Strings["ItemProperties.CancelBtn"];

  /** --- Validation --- */
  const isAddDisabled =
    propertyName.error ||
    propertyName.value.trim() === "" ||
    propertyName.success === false ||
    propertyName.value === initialValue.name;

  const isEditDisabled =
    propertyName.error ||
    description.error ||
    propertyName.value.trim() === "" ||
    description.value.trim() === "" ||
    (propertyName.success === false && description.success === false) ||
    (propertyName.value === initialValue.name &&
      description.value === initialValue.description);

  const isDisabled = actionType === "add" ? isAddDisabled : isEditDisabled;

  return (
    <div className="modalFormContainer">
      <h2>{actionType === "add" ? CreateTitle : EditTitle}</h2>

      {errorMessage && <h6 style={{ color: "red" }}>{errorMessage}</h6>}

      <FormTextInput
        type="textarea"
        label={NameLabel}
        starProps
        placeholder={NamePlaceholder}
        Value={propertyName.value}
        onChangeText={handleChangePropertyName}
        Validate
        CustomErrorLine={NameCustomError}
        editable
        maxLength={30}
      />

      <FormTextInput
        type="text"
        label={DescriptionLabel}
        placeholder={DescriptionPlaceholder}
        Value={description.value}
        onChangeText={handleChangeDescription}
        Validate={false}
        CustomErrorLine={DescriptionCustomError}
        multiline
        editable
        maxLength={50}
      />

      <div style={{ display: "flex", marginTop: "1.5rem" }}>
        <Button
          buttonName={actionType === "add" ? SaveBtn : UpdateBtn}
          buttonStyle={{ backgroundColor: colors.primary }}
          disable={isDisabled}
          onClick={handleSaveData}
        />
        <Button
          buttonName={CancelBtn}
          onClick={() => {
            handleModalClose();
            setMessage(null);
          }}
          buttonStyle={{ backgroundColor: colors.darkgrey, marginLeft: "10px" }}
        />
      </div>
    </div>
  );
};

export default ItemPropertiesForm;
